<template>
    <!-- protocol_search_container : S -->
    <div class="protocol_search_container">
        <div class="protocol_view_container">
            <div class="view_top_btn">
                <a href="javascript:void(0);" class="back_btn" @click="$emit('goToList');">목록으로</a>
            </div>
            <div class="view_head">
                <div class="protocol_search_item">
                    <div class="top_info">
                        <div class="txt_cont">
                            <div class="tit_label">
                                <span v-if="uniqueNumber" class="label_color color_02">{{protocolType}}<em>|</em>{{uniqueNumber}}</span>
                                <span v-else class="label_color color_02">{{protocolType}}</span>
                                <span class="label_gray">{{`${fieldName.split(">").join(" / ")}`}}</span>
                            </div>
                            <div class="tit_link" v-html="name">
                            </div>
                            <!--                현재 관리되고 있지 않은 데이터의 경우 빈 화면으로 퍼블리싱 적용 진행.​ -->
                            <!--                영문 한글명 토글 구현시 사용.-->
                            <!--                <p class="txt_info" v-html="nameEng"></p>-->
                            <!--                키워드의 경우 아직 관리되고 있지 않음.-->
                            <!--                <p class="txt_info">Skutterudite, CoSb3, 합성법, 열전소재, 에너지환경</p>-->
                            <ul class="protocol_label_list">
                                <li class="label_01 material"
                                    v-for="name in  material ? material.split(';') : []"
                                    v-if="name.trim() !== ''"
                                >
                                    <span>{{ name }}</span>
                                </li>
                                <li class="label_02 measurement"
                                    v-for="name in  measurement ? measurement.split(';') : []"
                                    v-if="name.trim() !== ''"
                                >
                                    <span>{{ name }}</span>
                                </li>
                                <li class="label_04 analysis"
                                    v-for="name in  analysis ? analysis.split(';') : []"
                                    v-if="name.trim() !== ''"
                                >
                                    <span>{{ name }}</span>
                                </li>
                                <li class="label_03 equipment"
                                    v-for="name in  equipment ? equipment.split(';') : []"
                                    v-if="name.trim() !== ''"
                                >
                                    <span>{{ name }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="bottom_info">
                        <ul class="user_set">
                            <li>{{lastEditDate}}
                            </li>
                            <li>책임작성자 : {{userData.name}}</li>
                            <li v-if="collaborators.length > 1">공동작성자 :
                                <span
                                        v-for="(collaborator,collaboratorKey) in collaborators"
                                        :key="collaboratorKey"
                                        v-if="collaboratorKey > 0"
                                >{{`${collaboratorKey != 1 ? " ,"+collaborator.name :collaborator.name}`}}</span>
                            </li>
                        </ul>
                        <ul class="btn_set">
                            <li><a href="javascript:void(0);" class="writer_more_btn"
                                   :class="writerListActive?'on':null" @click="writerListActive = !writerListActive">작성자
                                더보기</a></li>
                            <li class="process"
                                v-if="processType == 'NORMAL'"
                            ><a href="javascript:void(0);"
                                class="process_chart_btn"
                                @click="$emit('goToProcessDetail')"
                            >공정도 바로가기</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <ul class="protocol_writer_list" :class="writerListActive?'on':null"> <!--on-->
                    <li
                            v-for="(collaborator,collaboratorKey) in collaborators"
                            :key="collaboratorKey"
                    >
                        <ul class="writer_info">
                            <li class="user_name">
                                <div class="ico">
                                    <span class="icon_img"></span>
                                    <!--                                    <span class="icon_img txt">개정</span>-->
                                </div>
                                <div class="name">
                                    <strong>{{collaborator.name}}</strong>
                                    <span>{{`${collaboratorKey == 0 ? "책임작성자" : "공동작성자"}`}}</span>
                                </div>
                            </li>
                            <li>
                                <label>기관</label>
                                <p>{{`${collaborator.companyName?.length > 0 ? collaborator.companyName : "-"}`}}</p>
                            </li>
                            <li>
                                <label>소속</label>
                                <p>{{`${collaborator.belong?.length > 0 ? collaborator.belong : "-"}`}}</p>
                            </li>
                            <li>
                                <label>국가연구자번호</label>
                                <p>{{`${collaborator.researcherNumber?.length > 0 ? collaborator.researcherNumber :
                                    "-"}`}}</p>
                            </li>
                            <li>
                                <label>이메일</label>
                                <p>{{`${collaborator.email?.length > 0 ? collaborator.email : "-"}`}}</p>
                            </li>
                            <li>
                                <label>전화번호</label>
                                <p>{{`${collaborator.mobile?.length > 0 ? collaborator.mobile : "-"}`}}</p>
                            </li>
                            <li>
                                <label>연구분야</label>
                                <p>{{`${collaborator.researcherPart?.length > 0 ? collaborator.researcherPart :
                                    "-"}`}}</p>
                            </li>
                            <li>
                                <label>제정일</label>
                                <p>{{`${enactmentDate?.length > 0 ? enactmentDate : "-"}`}}</p>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <!-- view_head : E -->
            <div class="view_body">
                <!--                개요 데이터의 경우 현재 관리되고 있지 않기 때문에 주석처리.-->
<!--                <dl class="info_accodian" :class="infoAccodianActive?'open':null"> &lt;!&ndash;open&ndash;&gt;-->
<!--                    <dt-->
<!--                            @click="infoAccodianActive = !infoAccodianActive"-->
<!--                    >개요-->
<!--                    </dt>-->
<!--                    <dd>-->
<!--                        &lt;!&ndash;                        고성능 물질의 수요가 증가함에 따라, 표면 가공의 중요성도 커지고 있습니다. 물질의 표면은 외부 환경 및 기타 재질과 상호 작용하는 지점이며 부식율, 촉매-->
<!--                                                활성, 접착제-->
<!--                                                속성, 습윤성, 접촉 가능성 및 고장 메커니즘 등의 요인에 영향을 미칩니다. 이러한 특성을 변경 또는 개선하는 데 표면 수정이 활용될 수 있으며, 표면 분석은-->
<!--                                                표면의 화학적-->
<!--                                                특성을 이해하고 표면 가공의 효과를 검사하는 데 사용됩니다. 비접착성 조리기구 코팅부터 박막 전자 제품 및 바이오 활성 표면에 이르기까지, X선 광전자-->
<!--                                                분광학은 표면 특성-->
<!--                                                분석을 위한 표준 도구 중 하나입니다. X선 광전자 분광법(XPS)은 화학 분석(ESCA)을 위한 전자 분광 분석법으로도 알려져 있으며, 물질의 표면 화학-->
<!--                                                특성을 분석하는-->
<!--                                                기법입니다. XPS는 원소 구성은 물론 물질 내 원자의 화학적, 전자적 상태도 측정할 수 있습니다.&ndash;&gt;-->
<!--                    </dd>-->
<!--                </dl>-->
                <div class="protocol_detailtop">
                    <ul class="protocol_detailtop_tab">
                        <li :class="viewType==viewTepeList[0] ? 'on' : null" @click="tabSelect(0)"><a class="icon1"
                                                                                                      href="javascript:void(0);">트리보기</a>
                        </li>
                        <li :class="viewType==viewTepeList[1] ? 'on' : null" @click="tabSelect(1)"><a class="icon2"
                                                                                                      href="javascript:void(0);">위키보기</a>
                        </li>
                    </ul>
                    <div class="protocol_detailtop_btn">
                        <button type="button" v-if="processType == 'NORMAL'" @click="includedProtocolsActive = true">포함된 프로토콜 보기</button>
                        <button type="button" v-if="thisMyPage" @click="$emit('goToProtocolEditor');" class="edit">
                            수정하기
                        </button>
                    </div>
                </div>
                <!--                퍼블을 그대로 적용시 -->
                <div class="protocol_detail_cont">
                    <newTreeViewer v-if="viewType==viewTepeList[0]" :Data="treeViewData"></newTreeViewer>
                    <newWikiViewer v-else-if="viewType==viewTepeList[1]" :Data="wikiViewData"></newWikiViewer>
                </div>
            </div>
        </div>
        <!--         protocol_view_container : E -->
        <IncludedProtocols
                :inProcessId="inProcessId"
                :lastEditDate="lastEditDate"
                :active="includedProtocolsActive"
                :publishingActive="publishingActive"
                @goToDetail="goToDetail"
                @close="includedProtocolsActive = false"
        />
    </div>
    <!-- protocol_search_container : E -->
</template>

<script>
    import newTreeViewer from '@components/platform_new/newTreeViewer'
    import newWikiViewer from '@components/platform_new/newWikiViewer'
    import IncludedProtocols from "@/components/modal/IncludedProtocols";

    export default {
        props: {
            protocolDetailData: {type: Object, default: {}},
            thisMyPage: {
                type: Boolean, default: false
            },
            publishingActive: {
                type: Boolean, default: false
            },
        },
        data() {
            return {
                protocolId: "",
                inProcessId: 0,
                protocolType: "",
                fieldName: "",
                name: "",
                nameEng: "",
                viewData: null,
                treeViewData: null,
                wikiViewData: null,
                viewType: "",
                viewTepeList: ["tree", "wiki"],
                userData: {},
                equipment: null,
                measurement: null,
                analysis: null,
                material: null,
                editorMode: false,
                createdDate: "",
                updatedDate: "",
                lastEditDate: "",
                collaborators: [],
                writerListActive: false,
                infoAccodianActive: false,
                uniqueNumber: null,
                processType: "",
                // 제정일
                enactmentDate: "",
                // 개정일
                revisionDate: "",
                // 포함된 프로토콜 팝업 open 여부.
                includedProtocolsActive: false,
            }
        },
        components: {newTreeViewer, newWikiViewer, IncludedProtocols},
        watch: {
            async protocolDetailData(data) {
                if (!data) {
                    return;
                }
                this.init();
                this.treeViewData = data.json.issues;
                this.wikiViewData = data;
                if (data.viewType === this.viewTepeList[0]) {
                    this.viewType = this.viewTepeList[0];
                } else {
                    this.viewType = this.viewTepeList[1];
                }

                this.collaborators.unshift(this.userData);
                
                await this.setThumbnail();

                /** 로그 등록 */
                await this.$wApi.trace.log({
                    type: 'PR', //PD 공정도, PR 프로토콜
                    code: 'R', //N 생성 M 수정 S 검색 R 조회
                    subCode: '01',
                    keyword: '',
                    result: 1,
                    ptlId: data.protocolId
                });
            }
        },
        async mounted() {
            this.setThisData();
            this.init();

            this.treeViewData = this.protocolDetailData.json.issues;
            this.wikiViewData = this.protocolDetailData;
            if (this.protocolDetailData.viewType === this.viewTepeList[0]) {
                this.viewType = this.viewTepeList[0];
            } else {
                this.viewType = this.viewTepeList[1];
            }

            this.collaborators.unshift(this.userData);
            
            await this.setThumbnail();

            /** 로그 등록 */
            await this.$wApi.trace.log({
                type: 'PR', //PD 공정도, PR 프로토콜
                code: 'R', //N 생성 M 수정 S 검색 R 조회
                subCode: '01',
                keyword: '',
                result: 1,
                ptlId: this.protocolId
            });
        },
        methods: {
            async setThumbnail(){
                if(this.$route.query.beforeProcessId == null){
                    this.wikiViewData.thumbnail = null;
                    this.wikiViewData.beforeProcessId = null;
                }else{
                    let thumbnailData = null;
                    if(this.thisMyPage) {
                        thumbnailData = await this.$wApi.process.thumbnail.get(null, this.$route.query.beforeProcessId);
                    }else{ // 통합
                        thumbnailData = await this.$wApi.process.release.getThumbnail(null, this.$route.query.beforeProcessId);
                    }
                    this.wikiViewData.thumbnail = thumbnailData.thumbnail;
                    this.wikiViewData.beforeProcessId = this.$route.query.beforeProcessId;
                }
            },
            init() {
                this.setThisData();
                
                if(this.thisMyPage) {
                    // 최종 수정일 또는 생성일 화면에 보여줄 형식에 맞게 수정.
                    if (!this.updatedDate) {
                        this.lastEditDate = this.createdDate.substring(0, 10).split('-').join('.');
                    } else {
                        this.lastEditDate = this.updatedDate.substring(0, 10).split('-').join('.');
                    }

                    this.enactmentDate = this.enactmentDate?.substring(0, 10).split('-').join('.');
                    this.revisionDate = this.revisionDate?.substring(0, 10).split('-').join('.');
                }else{
                    if(this.revisionDate.length == 0){
                        this.lastEditDate = this.releaseDate.substring(0, 10).split('-').join('.');    
                        this.releaseDate = this.releaseDate?.substring(0, 10).split('-').join('.');
                    }else{
                        this.lastEditDate = this.revisionDate.substring(0, 10).split('-').join('.');
                    }
                }
            },
            async moveToProcessPage() {
                const processId = this.protocolDetailData.processId;
                const protocolId = this.protocolDetailData.keyOfProtocol;
                let path = '/protocol/editor';
                if (this.editerMode === false) {
                    window.alert('해당 문서의 수정권한을 가지고 있지 않습니다.');
                    return;
                }
                const {href} = this.$router.resolve({
                    path,
                    query: {
                        processId,
                        editorType: 'protocol',
                        protocolId
                    }
                });
                window.open(href, '_blank');
            },
            tabSelect(type) {
                type = this.viewTepeList[type]
                if (type === this.viewTepeList[0]) {
                    this.viewType = this.viewTepeList[0];
                } else {
                    this.viewType = this.viewTepeList[1];
                }
            },
            setThisData() {
                for (const item of Object.entries(this.protocolDetailData)) {
                    if (item[0] === "processId") {
                        this["inProcessId"] = item[1];
                    } else if (item[0] === "user") {
                        this["userData"] = item[1];
                    } else if (item[0] === "id") {
                        this["protocolId"] = item[1];
                    } else {
                        this[item[0]] = item[1];
                    }
                }
            },
            goToDetail(protocolId, viewMode, tabIndex) {
                this.$emit("goToProtocolDetail", protocolId, viewMode, tabIndex);
            },
        },

    }
</script>